const SEARCH_RESULTS_LOADING_MESSAGES = [
  "Analyzing search data, please wait...",
  "Running risk checks, one moment...",
  "Compiling your results...",
  "Evaluating information, hang tight...",
  "Fetching insights based on your input...",
  "Loading risk assessment results...",
];

const WATCH_LIST_SEARCH_RESULTS_LOADING_MESSAGES = [
  "Analyzing search data, please wait...",
  "Compiling your results...",
  "Evaluating information, hang tight...",
  "Fetching insights based on your input...",
];

export {
  SEARCH_RESULTS_LOADING_MESSAGES,
  WATCH_LIST_SEARCH_RESULTS_LOADING_MESSAGES,
};
